export default {
  title: {
    edit: 'Update the lane',
    create: 'Create a new lane',
  },
  form: {
    name: 'Label',
    sector: 'Sector',
    options: 'Options',
    option: {
      add: 'Add an option',
      with: 'with …',
      without: 'without …',
    },
    submit: 'Save',
  },
  formHelper: {
    options: 'The options allow the route setters to tell the climbers the possible subtleties or variants. For example, with/without edge of the wall',
  },
  error: {
    no_sector: 'You need to create a sector first.',
  },
  delete: {
    button: 'Delete this lane',
    confirm: {
      title: 'Please confirm the deletion of the "{{name}}" lane',
      warning_one: 'One route use this lane',
      warning_other: '{{count}} routes use this lane',
      helper: 'By deleting this lane, the related routes will be kept, but their lane will be empty.',
      submit: 'Supprimer',
    },
  },
}
